import {
   HealthcareProviderAppointmentCancellationPractitionerNotificationConfigurationQuery,
   HealthcareProviderNotificationConfiguration,
} from '@dreryk/egabinet-phone-notification-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';

type PractitionerPhoneNotificationAppointmentCancellationToggleLoaderRenderProps = {
   healthcareProviderNotificationConfiguration: HealthcareProviderNotificationConfiguration;
};

type PractitionerPhoneNotificationAppointmentCancellationToggleLoaderProps = {
   readonly children: (
      renderProps: PractitionerPhoneNotificationAppointmentCancellationToggleLoaderRenderProps
   ) => JSX.Element;
};

export const PractitionerPhoneNotificationAppointmentCancellationToggleLoader = (
   props: PractitionerPhoneNotificationAppointmentCancellationToggleLoaderProps
): JSX.Element | null => {
   const {
      data: healthcareProviderNotificationConfiguration,
      loading: healthcareProviderNotificationConfigurationLoading,
      error: healthcareProviderNotificationConfigurationError,
   } = useCqrsGet<HealthcareProviderNotificationConfiguration>(() => {
      return new HealthcareProviderAppointmentCancellationPractitionerNotificationConfigurationQuery();
   });

   if (
      healthcareProviderNotificationConfigurationLoading ||
      healthcareProviderNotificationConfigurationError ||
      !healthcareProviderNotificationConfiguration
   ) {
      return null;
   }

   return props.children({
      healthcareProviderNotificationConfiguration: healthcareProviderNotificationConfiguration,
   });
};
